import { SelectorMatchMap, SelectorMatchMapElementsEntry } from './types';

const ELEMENT_NOT_MATCHED = 'enm';

const element = (str: string): string => {
    const match = str.match(/^\w+/);
    return match ? match.toString() : ELEMENT_NOT_MATCHED;
};

const removeClassesAndIdsFromFirstNode = (selector: string): string =>
    selector.replace(/(^\w+)[^: ]*([^ ]*)/, (_, elm, nthChild = '') => elm + nthChild);
const removeFirstNode = (selector: string): string => selector.replace(/^[^\s]+\s?/, '');

const selectorToNodesArray = (selector: string): string[] =>
    selector.replace(/>/gi, '').replace(/  +/g, ' ').split(' ');

const incrementMatchedElements = (
    elements: Map<Element, SelectorMatchMapElementsEntry>,
    element: Element,
    selector: string
): Map<Element, SelectorMatchMapElementsEntry> => {
    const elementEntry: SelectorMatchMapElementsEntry | undefined = elements.get(element);
    elements.set(element, {
        selector,
        occurences: elementEntry ? elementEntry.occurences + 1 : 1,
    });
    return elements;
};

export const getNormalizedSelector = (selector: string, elementIgnoreList: string[] = []): string => {
    const selectorNodes = selectorToNodesArray(selector).filter(
        (node) => !elementIgnoreList.includes(element(node))
    );

    const { matchedElements }: SelectorMatchMap = selectorNodes.reduceRight(
        ({ matchingSelector, matchedElements }, node): SelectorMatchMap => {
            let updatedMatchingSelector = `${node} ${matchingSelector}`;
            let elm = document.querySelector(updatedMatchingSelector);

            if (elm) {
                return {
                    matchingSelector: updatedMatchingSelector,
                    matchedElements: incrementMatchedElements(
                        matchedElements,
                        elm,
                        updatedMatchingSelector
                    ),
                };
            }
            updatedMatchingSelector = removeClassesAndIdsFromFirstNode(updatedMatchingSelector);

            elm = document.querySelector(updatedMatchingSelector);
            return elm
                ? {
                      matchingSelector: updatedMatchingSelector,
                      matchedElements: incrementMatchedElements(
                          matchedElements,
                          elm,
                          updatedMatchingSelector
                      ),
                  }
                : ({
                      matchingSelector: removeFirstNode(updatedMatchingSelector),
                      matchedElements,
                  } as SelectorMatchMap);
        },
        {
            matchingSelector: '',
            matchedElements: new Map(),
        } as SelectorMatchMap
    );

    // I want to get rid of this as as as
    const mostOccuredElement = (
        Array.from(matchedElements.values()) as SelectorMatchMapElementsEntry[]
    ).reduce((acc, value) => (acc.occurences > value.occurences ? acc : value), {
        occurences: -1,
        selector: '',
    });
    const { selector: finalSelector } = mostOccuredElement;
    return finalSelector;
};

/** @todo: make the blacklist configurable */
export const elementBlacklist = ['span', 'img'];

export const getElementByCssPath = ({ path }: { path: string }): Element | null =>
    document.querySelector(getNormalizedSelector(path, elementBlacklist));
